import ng from 'angular';

export class NewToaster {
  static $inject = ['$rootScope'];

  constructor(private $rootScope: ng.IRootScopeService) { }

  public pop(params: {
    title: string;
    body: string;
    type: 'success' | 'error' | 'warning' | 'info';
    timeout?: number;
    bodyOutputType?: 'trustedHtml' | 'template' | 'templateWithData';
    clickHandler?: (...params: any) => {};
  }): void {
    // http errors carry request headers (including Authorization). Never render
    // the response object; only the API's textual message is suitable for users.
    if (params.type === 'error' && typeof params.body !== 'string') {
      const error: any = params.body;
      const message = error && error.data && error.data.message;
      this.$rootScope.$broadcast('new-toaster-pop', {
        ...params,
        body: typeof message === 'string' && message.trim()
          ? message
          : 'Não foi possível concluir a operação. Tente novamente.',
        bodyOutputType: undefined
      });
      return;
    }
    this.$rootScope.$broadcast('new-toaster-pop', params);
  }
}
